import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { IDownloadDocumentRequest } from '../models/download-document.model';
import { fromDownloadDocumentActions } from '../actions';

export const downloadDocumentFeatureKey = 'downloadDocument';

export interface DownloadDocumentState {
  loadDownloadDocumentRequest: IDownloadDocumentRequest;
  loadDownloadDocumentResponse: string;
  loadDownloadDocumentFailure: IGenericError<ErrorResponse>;
}

export const initialState: DownloadDocumentState = {
  loadDownloadDocumentRequest: undefined,
  loadDownloadDocumentResponse: undefined,
  loadDownloadDocumentFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(fromDownloadDocumentActions.loadDownloadDocuments, (state, action) => ({
    ...state,
    loadDownloadDocumentRequest: action.request
  })),
  on(fromDownloadDocumentActions.loadDownloadDocumentsSuccess, (state, action) => ({
    ...state,
    loadDownloadDocumentResponse: action.response
  })),
  on(fromDownloadDocumentActions.loadDownloadDocumentsFailure, (state, action) => ({
    ...state,
    loadDownloadDocumentFailure: action.error
  }))
);
